import { useRecord } from "./useRecord";

export function useOrganizationProfile(organizationId?: string | null) {
  return useRecord("organization_profile", organizationId, { name: "useOrganizationProfile" });
}
